var _style, _path, _path2, _g, _path3, _clipPath, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddToCartanimatedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@keyframes move{0%{offset-distance:0%}100%{offset-distance:100%}}@keyframes show{0%{fill-opacity:0}100%{fill-opacity:1}}@keyframes lineDraw{100%{stroke-dashoffset:0}}path[animId=bag]{stroke-dasharray:100;stroke-dashoffset:100;animation:lineDraw 500ms linear forwards}path[animId=handle]{stroke-dasharray:40;stroke-dashoffset:40;animation:lineDraw 500ms linear forwards 300ms}path[animId=box]{offset-path:path(&apos;M28.683,-2.684c-4.8,1.224 -6.938,5.062 -7.506,15.481&apos;);animation:move 1000ms ease-in-out forwards 500ms}path[animId=circle]{fill-opacity:0;will-change:fill-opacity;animation:show 250ms linear forwards 900ms}path[animId=arrow]{stroke-dasharray:20;stroke-dashoffset:20;animation:lineDraw 500ms linear forwards 1100ms}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    animId: "bag",
    d: "M9.99 8.52c-1.033.009-2.066.009-3.098 0a.492.492 0 00-.489.443L4.992 24.882v.045c0 1.706 1.574 3.093 3.513 3.093h12.348c1.939 0 3.513-1.387 3.513-3.093v-.045L22.95 8.963a.489.489 0 00-.489-.443H9.99z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    animId: "handle",
    d: "M10.5 11.52c-.759-5 .697-7.5 4.369-7.5 3.672 0 5.065 2.5 4.178 7.5",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "addToCart_animated_inline_svg__addToCart_animated_inline_svg__check"
  }, /*#__PURE__*/React.createElement("path", {
    animId: "circle",
    d: "M20.567 16.559c4.524 0 8.191 3.62 8.191 8.085 0 4.466-3.667 8.086-8.191 8.086-4.524 0-8.191-3.62-8.191-8.086 0-4.465 3.667-8.085 8.191-8.085z",
    fill: "#bbca8e"
  }), /*#__PURE__*/React.createElement("path", {
    animId: "arrow",
    d: "M24.662 22.219l-5.026 4.808a.16.16 0 01-.217.001l-2.402-2.235",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "addToCart_animated_inline_svg__addToCart_animated_inline_svg__mask",
    fill: "none",
    d: "M7.284 0h21.474v8.142H7.284z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "addToCart_animated_inline_svg__addToCart_animated_inline_svg___clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.284 0h21.474v8.142H7.284z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#addToCart_animated_inline_svg__addToCart_animated_inline_svg___clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    animId: "box",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75,
    strokeMiterlimit: 1.5,
    d: "M0 0h4.801v4.801H0z"
  }))));
}

export default SvgAddToCartanimatedinline;